export default "/images/arrow-up-square.svg?11bc12aa5a911760d06de4c8e5ecd66f";